(function() {
    $(document).ready(function() {

        $.fn.focusWithoutScrolling = function() {
            const x = window.scrollX;
            const y = window.scrollY;
            this.focus();
            window.scrollTo(x, y);
            return this;
        };

        $('.js24Autofocus').focusWithoutScrolling();

    });
})();
